/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetVersionPolicy200ResponseAndroid
 */
export interface GetVersionPolicy200ResponseAndroid {
    /**
     * 
     * @type {string}
     * @memberof GetVersionPolicy200ResponseAndroid
     */
    warningVersion: string;
    /**
     * 
     * @type {string}
     * @memberof GetVersionPolicy200ResponseAndroid
     */
    deprecatedVersion: string;
    /**
     * 
     * @type {number}
     * @memberof GetVersionPolicy200ResponseAndroid
     */
    webviewWarningVersion: number;
}

/**
 * Check if a given object implements the GetVersionPolicy200ResponseAndroid interface.
 */
export function instanceOfGetVersionPolicy200ResponseAndroid(value: object): value is GetVersionPolicy200ResponseAndroid {
    if (!('warningVersion' in value) || value['warningVersion'] === undefined) return false;
    if (!('deprecatedVersion' in value) || value['deprecatedVersion'] === undefined) return false;
    if (!('webviewWarningVersion' in value) || value['webviewWarningVersion'] === undefined) return false;
    return true;
}

export function GetVersionPolicy200ResponseAndroidFromJSON(json: any): GetVersionPolicy200ResponseAndroid {
    return GetVersionPolicy200ResponseAndroidFromJSONTyped(json, false);
}

export function GetVersionPolicy200ResponseAndroidFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetVersionPolicy200ResponseAndroid {
    if (json == null) {
        return json;
    }
    return {
        
        'warningVersion': json['warningVersion'],
        'deprecatedVersion': json['deprecatedVersion'],
        'webviewWarningVersion': json['webviewWarningVersion'],
    };
}

export function GetVersionPolicy200ResponseAndroidToJSON(json: any): GetVersionPolicy200ResponseAndroid {
    return GetVersionPolicy200ResponseAndroidToJSONTyped(json, false);
}

export function GetVersionPolicy200ResponseAndroidToJSONTyped(value?: GetVersionPolicy200ResponseAndroid | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warningVersion': value['warningVersion'],
        'deprecatedVersion': value['deprecatedVersion'],
        'webviewWarningVersion': value['webviewWarningVersion'],
    };
}

